import React from 'react';
import ColorIcon from './ColorIcon';
import { map } from 'lodash';
import { __ } from '../../../../core/utils';

export const colorOptions = map(
  [
    { key: 'red', hex: '#CA2D20' },
    { key: 'darkgreen', hex: '#004d00' },
    { key: 'blue', hex: '#5063D9' },
    { key: 'purple', hex: '#964BBC' },
    { key: 'orange', hex: '#ED6E2E' },
    { key: 'green', hex: '#58B539' },
    { key: 'lightblue', hex: '#00BFFF' },
    { key: 'lightpurple', hex: '#C88CE8' },
    { key: 'yellow', hex: '#FBF451' },
    { key: 'limegreen', hex: '#7FFF00' },
    { key: 'turquoise', hex: '#40E0D0' },
    { key: 'pink', hex: '#DC3183' },
    { key: 'black', hex: '#000000' },
    { key: 'grey', hex: '#999999' },
    { key: 'lightgrey', hex: '#D9D9D9' },
    { key: 'white', hex: '#FFFFFF' },
  ],
  ({ key, hex }) => ({
    key,
    hex,
    icon: () => <ColorIcon color={hex} />,
  })
);

// { key: 'red', label: 'Red', hex: '#FF0000' },
//     { key: 'orange', label: 'Orange', hex: '#FFA500' },
//     { key: 'gold', label: 'Gold', hex: '#FFD700' },
//     { key: 'limeGreen', label: 'Lime Green', hex: '#32CD32' },
//     { key: 'green', label: 'Green', hex: '#008000' },
//     { key: 'teal', label: 'Teal', hex: '#008080' },
//     { key: 'cyan', label: 'Cyan', hex: '#00FFFF' },
//     { key: 'skyBlue', label: 'Sky Blue', hex: '#87CEEB' },
//     { key: 'blue', label: 'Blue', hex: '#0000FF' },
//     { key: 'indigo', label: 'Indigo', hex: '#4B0082' },
//     { key: 'purple', label: 'Purple', hex: '#800080' },
//     { key: 'magenta', label: 'Magenta', hex: '#FF00FF' },
//     { key: 'brown', label: 'Brown', hex: '#8B4513' },
//     { key: 'pink', label: 'Pink', hex: '#FFC0CB' },
//     { key: 'darkGray', label: 'Dark Gray', hex: '#505050' },
//     { key: 'lightGray', label: 'Light Gray', hex: '#D3D3D3' },
